import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'
import storeUserFun from '@/home/sysMng/store'
import storeZhsqFun from '@/home/zhsq/store'
import storePage1Fun from '@/home/page1/store'
let storeFunc = defineStore("home",{
    state:()=>{
        return {
           //业务数据  count:99
           isLoginning:false,
           mainMenuData:[],
           selectMainMenu:100,
           loginUpdatePinerExTime:"",
           account:"",
           password:"",
           qrcode:"",

           //sysmngFunctions:null,
        }
    },
    actions:{
        load_sysmngMainMenu(callback,failback,router)
        {
             //console.log("home load sysmngMainMenu");
            let storeInfo = storeInfoFun();
        
            let url = storeInfo.linkUrl + "api/sysmngMainMenu/loadAll";
            Axs.get(url,null, null, (req) => {
            //  console.log(url + "   Data====>",req.data)
              if(req.status ==201)
              {
                callback(req);
                return;
              }
              this.mainMenuData = req.data;
             
              this.mainMenuData.forEach(element => {

              // console.log("element",element)
                let functionsRoute = {
                    name: "home_" + element.menuid,
                    path: "" + element.menuid, 
                    components:{
                      homelayouts:()=>import('@/home/' + element.functionName + '/index.vue'),
                    },
      
                }
               // debugger;
               
                router.addRoute("home",functionsRoute)
          
            });
           // console.log("router.getRoutes2222()=>",router.getRoutes())
              if(!Util.isEmpty(callback))
              {
                callback(req);
              }
            },(err)=>{
          
                if(!Util.isEmpty(failback))
                {
                    failback(err);
                }

            })
        },

        getSelectMainMenu()
        {
            let find = null;
            this.mainMenuData.forEach(element => {
                if(Number(element.menuid) == this.selectMainMenu)
                {
                    find = element
                }
            })
            return find;
        },

        getSelectMainMenuById(id)
        {
            let find = null;
            this.mainMenuData.forEach(element => {
                if(Number(element.id) == id)
                {
                    find = element
                }
            })
            return find;
        },

        clear()
        {
            storeUserFun().clear();
            storeZhsqFun().clear();
            storePage1Fun().clear();
            this.mainMenuData =[];
            this.selectMainMenu=100;
            this.loginUpdatePinerExTime ="";
        },

        relogin()
        {
    
            let storeInfo = storeInfoFun();
            let _url = storeInfo.linkUrl + "api/relogin";
            //console.log(_url)
            Axs.post(_url, {},null, null, (req) => {
            //  console.log("api/login req=",req)
      
              if(req.status == 201)
              {
                return;
              }
            //  console.log("重新登录 api/login req=",req)
              this.loginUpdatePinerExTime = (new Date()).getTime();
              let storeUser = storeUserFun();
              storeUser.loginData(req.data);
     
            },()=>{
             
            });


        }
    },
    getters:{
        //计算属性，只读属性
   
    },
    persist: true
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc